<template>
  <div>
    <div class="steps">
      <div class="step" style="width:50%;"></div>
      <div class="step animated slideInLeft" style="width:50%;"></div>
    </div>

    <div class="container py-5">
      <div class="row">
        <div class="col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 text-center">
          <i class="fal fa-3x fa-check-circle green animated pulse"></i>
          <h1 class="h4 mt-3">Success!</h1>
          <p v-if="newTireReport && newTireReport.registrationNumber" class="grey mb-2">Tire report on <span class="easy-select">{{newTireReport.registrationNumber}}</span> completed.</p>
          <p v-if="isPNOuser && internalTireReportUrl" class="small"><a :href="internalTireReportUrl" target="_blank">View tire report<i class="fal fa-external-link-square ml-1"></i></a></p>
          <hr class="my-4">
          <router-link :to="{ name: 'frontpage' }" class="btn btn-info mt-2">New tire report</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  metaInfo: {
    title: 'Success!'
  },
  computed: {
    ...mapState("tireReports", ["newTireReport"]),
    ...mapState("user", ["claims"]),
    isPNOuser(){
      return this.claims && this.claims.pno
    },
    internalTireReportUrl(){
      if(!this.newTireReport || !this.newTireReport.tireReportId ||!window.envConfig.INTERNAL_UI_BASEURL) return ""
      return `${window.envConfig.INTERNAL_UI_BASEURL}/tires/${this.newTireReport.tireReportId}?utm_source=tires`
    },
  },
  mounted() {
    this.loadUser();
    if (!this.newTireReport || !this.newTireReport.tireReportId) {
      this.$router.replace({ name: "frontpage" });
    }
  },
  methods: {
    ...mapActions('user', ['loadUser'])
  }
}
</script>
